/* CUSTOM: Global entry point — helpers that run on every page (product-card state sync, Klaviyo analytics bridge).
   Page-specific controllers live in custom-collection.js and custom-product.js; all loaded from snippets/custom-global-head-assets.liquid. */
(() => {
  // --- CUSTOM SCRIPT START: Product card variant state sync (price, badges, quick buy) ---
  // Swatch change on a card: replace badges and price from the card's <template data-custom-card-state>.
  document.addEventListener("change", (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement)) {
      return;
    }

    if (!target.matches('.product-card__info input[type="radio"][data-variant-id]')) {
      return;
    }

    const card = target.closest("product-card");

    if (!card) {
      return;
    }

    const variantId = target.getAttribute("data-variant-id");

    if (!variantId) {
      return;
    }

    // Quick buy follows the chosen color: the theme rewrites the card links on swatch change, not the modal's handle.
    // Looked up by id, because an open modal sits on <body>, not in the card.
    const quickBuyButton = card.querySelector(".product-card__quick-add-button[aria-controls]");
    const quickBuyModal = quickBuyButton ? document.getElementById(quickBuyButton.getAttribute("aria-controls")) : null;
    const productUrl = target.getAttribute("data-product-url");

    if (quickBuyModal && productUrl) {
      const url = new URL(productUrl, window.location.origin);
      const handle = url.pathname.split("/products/")[1];

      if (handle) {
        quickBuyModal.setAttribute("handle", `${handle}${url.search}`);
      }
    }

    const stateTemplate = card.querySelector(`template[data-custom-card-state="${variantId}"]`);

    if (!(stateTemplate instanceof HTMLTemplateElement)) {
      return;
    }

    const stateFragment = stateTemplate.content.cloneNode(true);
    const nextBadges = stateFragment.querySelector("[data-custom-state-badges]");
    const nextPrice = stateFragment.querySelector("[data-custom-state-price]");

    const figure = card.querySelector(".product-card__figure");
    const badgesHost = card.querySelector("badge-list[data-custom-card-badges]");
    const priceHost = card.querySelector("[data-custom-card-price]");

    if (nextBadges) {
      const nextBadgeList = nextBadges.querySelector("badge-list[data-custom-card-badges]");

      if (nextBadgeList) {
        if (badgesHost) {
          badgesHost.replaceWith(nextBadgeList.cloneNode(true));
        } else if (figure) {
          figure.prepend(nextBadgeList.cloneNode(true));
        }
      } else if (badgesHost) {
        badgesHost.remove();
      }
    } else if (badgesHost) {
      badgesHost.remove();
    }

    if (priceHost) {
      priceHost.replaceChildren();

      if (nextPrice) {
        priceHost.innerHTML = nextPrice.innerHTML;
      }
    }
  });
  // --- CUSTOM SCRIPT END: Product card variant state sync (price, badges, quick buy) ---

  // --- CUSTOM SCRIPT START: Klaviyo form submit analytics bridge ---
  // Forwards Klaviyo form submits to Shopify web pixels as `klaviyo_form_submit`.
  function onKlaviyoFormSubmit(e) {
    try {
      const d = e.detail || {};
      const formId = d.formId || d.formID || null;
      const formTitle = d.formTitle || d.metaData?.formTitle || null;
      const formEmail = d.metaData?.email || d.email || null;

      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish("klaviyo_form_submit", {
          formId: formId,
          formTitle: formTitle,
          formEmail: formEmail,
        });
      }
    } catch (err) {
      console.warn("Klaviyo bridge error", err);
    }
  }

  window.addEventListener("klaviyoForms", (e) => {
    if (e?.detail?.type === "submit") onKlaviyoFormSubmit(e);
  });
  // --- CUSTOM SCRIPT END: Klaviyo form submit analytics bridge ---
})();
